module.exports = __webpack_public_path__ + "img/7.bac66e75.png";